module.exports = __webpack_public_path__ + "static/img/detail_info.3c38233c.svg";